module.exports = __webpack_public_path__ + "img/fetchLogo.48b53b97.png";